

































import { Component, Prop, Vue } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { formatCurrency } from "@/shared/currency";
import { DrivewealthTransactionUnit, InstrumentDetail } from "@/shared/types";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

@Component({
  computed: {
    DrivewealthTransactionUnit () {
      return DrivewealthTransactionUnit;
    },
  },
  components: {}
})
export default class SharePriceTable extends Vue {
  @Prop({ required: true }) amountUsd: number;
  @Prop({ required: false }) amountShares: number;
  @Prop({ required: true }) symbol: string;
  @Prop({ default: DrivewealthTransactionUnit.ByAmount }) selectedTransactionUnit: DrivewealthTransactionUnit;

  drivewealthStore = useDrivewealthStore();

  formatCurrency = formatCurrency;
  $validator: Validator;

  get instrumentDetail (): InstrumentDetail {
    return this.drivewealthStore.cachedInstrumentDetailBySymbol(this.symbol);
  }

  get displayComputedShares (): boolean {
    return this.selectedTransactionUnit === DrivewealthTransactionUnit.ByAmount;
  }

  get computedNumberOfShares (): string {
    if (!this.instrumentDetail ||
        this.instrumentDetail.currentPrice === undefined ||
        this.instrumentDetail.currentPrice === null ||
        this.instrumentDetail.currentPrice === 0) {
      return "0";
    }
    return (this.amountUsd / this.instrumentDetail.currentPrice).toFixed(6);
  }

  get computedAmountUsd (): string {
    if (!this.instrumentDetail ||
        this.instrumentDetail.currentPrice === undefined ||
        this.instrumentDetail.currentPrice === null ||
        this.instrumentDetail.currentPrice === 0 ||
        isNaN(this.amountShares)) {
      return "$0.00";
    }

    return formatCurrency(this.amountShares * this.instrumentDetail.currentPrice);
  }
}
